export default __webpack_public_path__ + "static/media/BookIcon.718f0339.svg";